import { render, staticRenderFns } from "./CircularLoader.vue?vue&type=template&id=44510f5a&"
import script from "./CircularLoader.vue?vue&type=script&lang=js&"
export * from "./CircularLoader.vue?vue&type=script&lang=js&"
import style0 from "./CircularLoader.vue?vue&type=style&index=0&module=true&lang=postcss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports